import $ from './jquery.js';

$('body').on('click', '[data-toggle-class]', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var target = $($(this).attr('href'));
    target.toggleClass($(this).data('toggle-class'));
    
    if(target.hasClass($(this).data('toggle-class'))) {
        $('body').on('click', closeTarget);
    }
    else {
        $('body').off('click', closeTarget);
    }

    function closeTarget(e) {
        if(!$.contains(target[0], e.target)) {
            target.removeClass('active');
            $('body').off('click', closeTarget);
        }
    }
});
